module.exports = __webpack_public_path__ + "img/razi-logo-v1.d2d753e3.png";